<template>
  <div class="productProcess">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.WORKMANSHIP') }}
    </div>
    <div class="productProcess-list" v-for="(item, index) in data" :key="index">
      <!-- <div class="button-group">
        <a-button type="primary" size="small" @click="saveProductProcess(item)"
          >保存</a-button
        >
      </div> -->
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Dye_Lot') }}：</span>
        <a-input v-model="item.fabricWorkmanship.workDyelot"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Roll_Number') }}：</span>
        <a-input v-model="item.fabricWorkmanship.workRollnumber"></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Defect_Description') }}：</span>
        <a-input
          v-model="item.fabricWorkmanship.workDefectdescription"
        ></a-input>
      </div>
      <div class="dian1">
        <span>{{ $tc('lang.FabricReport.Points') }}：</span>
        <a-input v-model="item.fabricWorkmanship.workPoints"></a-input>
      </div>
      <div class="desOfGoods-con">
        <span>{{ $tc('lang.FabricReport.Defect') }}</span>
        <div class="img">
          <show-img
            :data="item.media"
            :otherData="{
              mediaName: '疵点照片',
              mediaType: 3,
              personId: '',
              orderId: '',
              reportId: '',
              mediaDesc: '',
            }"
            :id="id"
          ></show-img>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  data() {
    return {
      data: [],
      id: this.$route.query.id,
    };
  },
  computed: {
    fabricDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.fabricDetails),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {
    this.getSelectDate();
  },
  methods: {
    //获取数据
    getSelectDate() {
      this.$http
        .post('/hzwmj/fabric-workmanship/seachFabricWorkmanship', {
          lreportId: this.fabricDetails.freportId,
        })
        .then(data => {
          if (data) {
            data.data.forEach(item => {
              if (item.media == null) {
                item.media = [];
              }
            });
            this.data = data.data;
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
    //保存
    saveProductProcess(value) {
      let list = [];
      let imgList = [];
      value.media.forEach(item => {
        imgList.push(item.id);
      });
      const fabricWorkmanship = value.fabricWorkmanship;
      list.push({
        ...fabricWorkmanship,
        modelType: '4',
        workDefectphoto: imgList.join(','),
      });
      this.$http
        .post('/hzwmj/fabric-workmanship/saveorUpdateFabricWorkmanship', {
          data: list,
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            this.getSelectDate();
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    deleteImg(id) {
      this.$http
        .post('/hzwmj/inspect-defect/delectInspectDefect', {
          id: id,
        })
        .then(data => {
          if (data) {
            this.$message.success('删除成功');
            this.getSelectDate();
          } else {
            this.$message.error('删除失败');
          }
        })
        .catch(() => {
          this.$message.error('删除失败');
        });
    },
    cancel() {},
  },
};
</script>
<style lang="less">
.productProcess {
  .productProcess-list {
    margin-bottom: 20px;
  }
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .dian1 {
    margin-bottom: 10px;
    > span:nth-child(1) {
      width: 120px;
      padding-left: 20px;
      display: inline-block;
    }
    input {
      width: 150px;
    }
    .ant-radio-group {
      width: 220px;
    }
  }
}
</style>
